const Cases = [
    {
        name: 'Lagos',
        isCases: '12',
        isPositive: '10',
        isNegative: '0',
        isRecovered: '7',
        isDeath: '2'
    },
  
    {
        name: 'Ibadan',
        isCases: '2',
        isPositive: '1',
        isNegative: '0',
        isRecovered: '0',
        isDeath: '0'
    },
    {
      name: 'Saki',
      isCases: '0',
      isPositive: '0',
      isNegative: '0',
      isRecovered: '0',
      isDeath: '0'
  },
  ]

export default Cases;